import { Field } from "react-final-form";
import { Button, Col, Label, Row } from "reactstrap";
import { nameof } from "../../app/Utils";
import { CashDeskSimulatorProps } from "../CashDeskSimulator";
import { ReceiptDetailDto } from "../../../store/models/CustomerInteractionDto";
import { ProductCard } from "./components/ProductCard";

const handleProductClick = (props: any, refNumber: string) => {
  const newValue = props.input.value.includes(refNumber)
    ? props.input.value.filter((id: string) => id !== refNumber)
    : [...props.input.value, refNumber];
  props.input.onChange(newValue);
};

interface ReceiptDetailPanelBaseProps {
  examples: ReceiptDetailDto[];
  imageFolder: string;
}

export const ReceiptDetailPanelBase = ({ examples, imageFolder }: ReceiptDetailPanelBaseProps) => (
  <>
    <Row>
      <Col md={9}>
        <Label for={nameof<CashDeskSimulatorProps>("receiptDetailIds")}>Produkte wählen</Label>
      </Col>
    </Row>
    <Row>
      <Field name={nameof<CashDeskSimulatorProps>("receiptDetailIds")} type="field">
        {(props) =>
          examples.map((example) => (
            <Col md={4} key={example.itemInfo.refNumber}>
              <Button
                color="link"
                onClick={() => handleProductClick(props, example.itemInfo.refNumber)}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <ProductCard
                  product={example}
                  imageFolder={imageFolder}
                  isSelected={props.input.value.includes(example.itemInfo.refNumber)}
                  onClick={() => handleProductClick(props, example.itemInfo.refNumber)}
                />
              </Button>
            </Col>
          ))
        }
      </Field>
    </Row>
  </>
);